import { TextBlock } from '../../model'

class Blockquote extends TextBlock {}

Blockquote.type = "blockquote"

export default Blockquote
